import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-yoga-about',
  templateUrl: './yoga-about.component.html',
  styleUrls: ['./yoga-about.component.scss']
})
export class YogaAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
